import { create } from 'zustand';
import { SelectedData, WorkSimpleForExportData } from '../dto/EntityRepository';
import { WORK_LIST_EXPORT_MAX_ROWS } from '../constants/limits';

interface ExportStationWorkState {
  selectedDataList: SelectedData[];
  setSelectedDataList: (list: SelectedData[]) => void;
  addSelectedData: (data: SelectedData) => void;
  removeSelectedData: (data: SelectedData) => void;
  clearSelectedDataList: () => void;
  simpleList: WorkSimpleForExportData[];
  setSimpleList: (list: WorkSimpleForExportData[]) => void;
  clearSimpleList: () => void;
}

const isSameSelection = (a: SelectedData, b: SelectedData) =>
  a.workId === b.workId && a.detailId === b.detailId;

export const useExportStationWorkStore = create<ExportStationWorkState>((set) => ({
  selectedDataList: [],
  setSelectedDataList: (list) => set({ selectedDataList: list }),
  addSelectedData: (data) =>
    set((state) => {
      if (state.selectedDataList.some((s) => isSameSelection(s, data))) return state;
      if (state.selectedDataList.length >= WORK_LIST_EXPORT_MAX_ROWS) return state;
      return { selectedDataList: [...state.selectedDataList, data] };
    }),
  removeSelectedData: (data) =>
    set((state) => ({
      selectedDataList: state.selectedDataList.filter((s) => !isSameSelection(s, data)),
    })),
  clearSelectedDataList: () => set({ selectedDataList: [] }),
  simpleList: [],
  setSimpleList: (list) => set({ simpleList: list }),
  clearSimpleList: () =>
    set({
      selectedDataList: [],
      simpleList: [],
    }),
}));
